import React from "react"
import styled from "styled-components"
import colors from "@constants/colors"
import animation, { cubicBezier } from "@constants/animation"
import breakpoints from "@constants/breakpoints"
import { smallcapsBold14Styles } from "@constants/typography"
import ImageHelper, {
  Container as ImageHelperContainer,
} from "@components/ImageHelper"

const Container = styled.div`
  flex-wrap: wrap;
  align-items: flex-start;
  display: flex;
`

export const ImageWrapper = styled.div<{ showHover: boolean }>`
  position: relative;
  width: 80px;
  height: 80px;
  margin-right: 12px;
  margin-bottom: 12px;
  padding: 0px;
  transition: background-color ${animation.quick} ${cubicBezier};
  background-color: ${colors.reviewGray};

  @media ${breakpoints.laptop} {
    &:hover {
      background-color: ${colors.reviewGrayHover};
      cursor: ${({ showHover }) => (showHover ? "pointer" : "default")};
    }
  }

  ${ImageHelperContainer} {
    flex-grow: 0;
    flex-shrink: 0;
    width: 100%;
    height: auto;

    img {
      object-fit: contain;
    }
  }
`

const Count = styled.div<{ showHover: boolean }>`
  ${smallcapsBold14Styles}
  align-items: center;
  justify-content: center;
  display: flex;
  width: 80px;
  height: 80px;
  transition: background-color ${animation.quick} ${cubicBezier};
  background-color: ${colors.backgroundGrayHover};
  color: ${colors.black};

  @media ${breakpoints.laptop} {
    &:hover {
      background-color: ${colors.backgroundGrayHoverHover};
      cursor: ${({ showHover }) => (showHover ? "pointer" : "default")};
    }
  }
`

export interface ImageThumbnailsProps {
  images: Array<{
    alt?: string
    image: string
    thumbnail?: string
    onClick?: () => void
  }>
  imagesToShow?: number
  onClickCount?: () => void
}

const ImageThumbnails: React.FC<ImageThumbnailsProps> = ({
  images,
  imagesToShow,
  onClickCount,
}) => {
  const imagesToRender = images.slice(0, imagesToShow || 4)

  return (
    <Container>
      {imagesToRender.map((image, index) => (
        <ImageWrapper
          key={`${index}-${image.image}`}
          onClick={image.onClick}
          showHover={!!image.onClick}
        >
          <ImageHelper
            src={image.thumbnail || image.image}
            alt={image.alt || ""}
          />
        </ImageWrapper>
      ))}
      {imagesToRender.length < images.length && (
        <Count onClick={onClickCount} showHover={!!onClickCount}>
          +{images.length - imagesToRender.length}
        </Count>
      )}
    </Container>
  )
}

export default ImageThumbnails
